import React from 'react';
import './Ellipsis.scss'

export default function Ellipsis() {
  return (
    <div className="ellipsis"><span></span> <span></span> <span></span></div>
  )
}



// WEBPACK FOOTER //
// ./modules/Common/components/Ellipsis.js